function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32,4.22a30.76,30.76,0,0,0-3.86.26,4.22,4.22,0,0,1,0,.52V8.52A24,24,0,0,1,32,8.22a26.46,26.46,0,0,1,3.58.26V6.78A7.08,7.08,0,0,1,36,4.5,28.84,28.84,0,0,0,32,4.22Zm-24,28A23.84,23.84,0,0,1,13.8,16.6V11A28,28,0,0,0,17.26,56V51.14A23.94,23.94,0,0,1,8,32.22Zm24,24a24.31,24.31,0,0,1-7.28-1.12v4.16a28.16,28.16,0,0,0,7.28,1,28.5,28.5,0,0,0,7.08-.9V55.16A24.36,24.36,0,0,1,32,56.22ZM57,19.6V23H54.16a24,24,0,0,1-7.58,28.26v4.86A28,28,0,0,0,57,19.6Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M44.58,4.62V7H41V17h3.58V60.32a2,2,0,0,1-1.76,2.16,2,2,0,0,1-1.74-2.16V34.62a2,2,0,0,0-1.76-2.14,2,2,0,0,1-1.74-2.16V6.78A4.7,4.7,0,0,1,38,4.86a3.46,3.46,0,0,1,3.12-2.38h1.74A2,2,0,0,1,44.58,4.62Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.18,5V22.58a2,2,0,0,1-1.74,2.14,2,2,0,0,0-1.72,2.12V60A2,2,0,0,1,21,62.08,2,2,0,0,1,19.26,60V26.84a2,2,0,0,0-1.72-2.12,2,2,0,0,1-1.74-2.14V5a2,2,0,0,1,1.74-2.14h.62V19.62a.83.83,0,0,0,1.66,0V2.86h2.36V19.62a.83.83,0,0,0,.84.82.81.81,0,0,0,.82-.82V2.86h.6a1.9,1.9,0,0,1,1.72,2A.55.55,0,0,1,26.18,5Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M56,8V2H48V8H42v8h6v6h8V16h6V8Zm4,6H54v6H50V14H44V10h6V4h4v6h6Z"
});

var SvgMealPlanPlus = function SvgMealPlanPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMealPlanPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MealPlan_Plus.baefc017.svg";
export { ForwardRef as ReactComponent };